import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{attrs:{"color":_vm.color,"timeout":_vm.timeout,"bottom":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_c(VBtn,{attrs:{"dark":"","text":""},on:{"click":function($event){_vm.snackbar = false}}},[_c(VIcon,[_vm._v("close")])],1),_vm._v(" "+_vm._s(_vm.getMessage)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }